import {
	fillAddressFromDoc,
	reverseGeocode,
	lookupById,
} from "../utils/index.js";

const currentLocationIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true">
	<path d="M320 48C337.7 48 352 62.3 352 80L352 98.3C450.1 112.3 527.7 189.9 541.7 288L560 288C577.7 288 592 302.3 592 320C592 337.7 577.7 352 560 352L541.7 352C527.7 450.1 450.1 527.7 352 541.7L352 560C352 577.7 337.7 592 320 592C302.3 592 288 577.7 288 560L288 541.7C189.9 527.7 112.3 450.1 98.3 352L80 352C62.3 352 48 337.7 48 320C48 302.3 62.3 288 80 288L98.3 288C112.3 189.9 189.9 112.3 288 98.3L288 80C288 62.3 302.3 48 320 48zM160 320C160 408.4 231.6 480 320 480C408.4 480 480 408.4 480 320C480 231.6 408.4 160 320 160C231.6 160 160 231.6 160 320zM320 224C373 224 416 267 416 320C416 373 373 416 320 416C267 416 224 373 224 320C224 267 267 224 320 224z"/>
</svg>`;

const ERROR_CLASS = "acf-location-share-btn-error";

function showLocationError(btn) {
	btn.classList.add(ERROR_CLASS);
	setTimeout(() => btn.classList.remove(ERROR_CLASS), 3000);
}

export function addLocationShareButton(field, index, context) {
	const { apiRequest, apiReverseUrl, apiLookupUrl, apiLookupIdParam } = context;

	const anchorName = `--acf-address-input-${index}`;
	field.style.anchorName = anchorName;

	const btn = document.createElement("button");
	btn.type = "button";
	btn.className = "acf-location-share-btn";
	btn.innerHTML = currentLocationIcon + '<span class="sr-only">Gebruik huidige locatie</span>';
	btn.style.positionAnchor = anchorName;
	btn.addEventListener("click", async () => {
		if (!navigator.geolocation) {
			return;
		}
		btn.disabled = true;
		btn.setAttribute("aria-busy", "true");
		try {
			const coords = await new Promise((resolve, reject) => {
				navigator.geolocation.getCurrentPosition(
					({ coords }) => resolve(coords),
					reject,
				);
			});

			// Step 1 — reverse geocode to get the nearest address id
			const reverseDoc = await reverseGeocode(
				apiRequest,
				apiReverseUrl,
				coords,
			);
			if (!reverseDoc?.id) {
				showLocationError(btn);
				return;
			}

			// Step 2 — lookup full doc by id (reverse returns minimal fields)
			const lookupDoc = await lookupById(
				apiRequest,
				apiLookupUrl,
				apiLookupIdParam,
				reverseDoc.id,
			);
			if (!lookupDoc) {
				showLocationError(btn);
				return;
			}

			// Step 3 — fill the address input, hidden field and map pin
			fillAddressFromDoc(field, lookupDoc);
		} catch (error) {
			console.error("Location fetch failed", error);
			showLocationError(btn);
		} finally {
			btn.disabled = false;
			btn.removeAttribute("aria-busy");
		}
	});
	field.parentNode.appendChild(btn);
}
